export default __webpack_public_path__ + "static/media/valley9.9419e5ec.png";